/**
 * TIER 1, reached from a GATE rather than from onboarding.
 *
 * This is where the gate's single primary action lands. UF_00 section 5: the gate "states what is
 * locked, why, which tier unlocks it, and a single primary action to start the required
 * verification" — and that action must arrive somewhere that finishes the job, or the gate is a dead
 * end with a button on it.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tier1Form, UnderReview } from '@/components/kyc-forms';
import { useSession } from '@/lib/session-context';

export default function VerifyTier1() {
  const navigate = useNavigate();
  const { me, refresh } = useSession();
  const [held, setHeld] = useState(false);

  if (!me) return null;
  if (held) return <UnderReview />;

  return (
    <div className="mx-auto max-w-md space-y-5">
      <header>
        <h1 className="text-page-title text-ink">Verify your identity</h1>
        <p className="mt-1 text-sm text-ink-muted">
          We check the name on your ID against sanctions, PEP, and watchlists. This is what makes
          VASP a whitelisted environment, and it is why nobody transacts anonymously here.
        </p>
      </header>

      <div className="rounded-card border border-border bg-surface p-5">
        <Tier1Form
          participantId={me.participant_id}
          onDone={async (outcome) => {
            if (outcome === 'under_review') {
              setHeld(true);
              return;
            }

            // Pull the new tier from the SERVER before navigating. Setting it locally would make the
            // app briefly disagree with the platform about what this person is allowed to do, and the
            // app would be the one that was wrong.
            await refresh();
            navigate('/home');
          }}
        />
      </div>
    </div>
  );
}
